<template>
    <div>
        <el-input v-model="input" placeholder="请输入内容"></el-input>
    </div>
</template>

<script>
  export default {
    name: "ease-chat",
    data() {
      return {
        input: ''
      };
    }

  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/lib/easeChat.vue